/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
// import { useDispatch } from "react-redux"

import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
// import { AppDispatch } from "../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T営業所管マスタ } from "../../../components/ComboBox/EigyosyokanComboBox"
// import ConfirmModal from "../../components/ConfirmModal"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import BusyoService from "../../../service/master/busyo/busyoService"
import {
  TBusyoInfoGetRes,
  TBusyoListGetReq,
} from "../../../service/master/busyo/TBusyo"

import {
  マスタ管理メニューコード,
  メニューコード,
} from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import EigyosyoKanService from "../../../service/master/eigyosyoKan/eigyosyoKanService"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import { RootState } from "../../../globalStore/rootreducer"

/**
 * 部所マスタ一覧
 * @returns
 */
const MasterBusyoList = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.部所マスタ
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "MasterBusyoList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TBusyoListGetReq,
    signal?: AbortSignal
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBusyoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new BusyoService().getList(
        currentSearchCondition,
        signal
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TBusyoListGetReq = queryString.parse(location.search)
    set営業所管コード(query.営業所管コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBusyoListGetReq => {
    return {
      営業所管コード: 営業所管コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TBusyoListGetReq) => {
    return {
      営業所管: 営業所管ItemSource?.find(
        (i) => i.営業所管コード === searchCondition.営業所管コード
      )?.営業所管名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set営業所管コード("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]
  const [営業所管コード, set営業所管コード] = useState<string | null>()
  const [営業所管ItemSource, set営業所管ItemSource] =
    useState<T営業所管マスタ[]>()

  //#region [comboboxState]
  // 営業所管
  const [営業所管ComboBox, set営業所管ComboBox] = useState<TWijmoComboBox<
    T営業所管マスタ["営業所管コード"],
    T営業所管マスタ
  > | null>(null)
  const [営業所管IsLoadEnded, set営業所管IsLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new EigyosyoKanService().getList()]).then(([営業所管Res]) => {
      set営業所管ItemSource(営業所管Res.data)
    })
  }, [])

  useEffect(() => {
    if (!営業所管IsLoadEnded) return

    setComboDataInitialized(true)
  }, [営業所管IsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    const abortController = new AbortController()
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition, abortController.signal).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
    return () => {
      abortController.abort()
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `部所マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">部所マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-75rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <ComboBox.Eigyosyokan
                              placeholder="営業所管"
                              isLoadEnded={営業所管IsLoadEnded}
                              setIsLoadEnded={set営業所管IsLoadEnded}
                              isAllSelect={true}
                              itemsSource={営業所管ItemSource}
                              selectedValue={営業所管コード}
                              setSelectedValue={set営業所管コード}
                              ComboBox={営業所管ComboBox}
                              setComboBox={
                                set営業所管ComboBox
                              }></ComboBox.Eigyosyokan>
                            <Button
                              type="submit"
                              className="ms-auto"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Link
                        to={
                          util.getMenuPath(
                            マスタ管理メニューコード.部所マスタ登録
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          新規追加
                        </Button>
                      </Link>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TBusyoInfoGetRes>
                    ) => {
                      // 部所登録
                      const url = util.getMenuPath(
                        マスタ管理メニューコード.部所マスタ登録
                      )[1]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            //TODO: 受け渡すパラメータ確定後修正
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.部所ID.toString()
                              )
                            )
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="会社コード"
                  width={100}
                  header="会社CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="会社名"
                  width={200}
                  header="会社名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="営業所コード"
                  width={100}
                  header="営業所CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="営業所名"
                  width={200}
                  header="営業所名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所コード"
                  width={100}
                  header="部所CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={200}
                  header="部所名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  width={150}
                  header="部所略称"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="運行部所フラグ"
                  width={100}
                  dataType={wjCore.DataType.Boolean}
                  header="運行部所"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default MasterBusyoList
